export const ASTEROID_PRESETS = {
    "Impactor-2025": { diameterM: 200, speedKms: 19, angleDeg: 45 },
    "CityBuster": { diameterM: 80, speedKms: 22, angleDeg: 35 },
    "Regional-140m": { diameterM: 140, speedKms: 25, angleDeg: 50 },
    "OceanTsunami": { diameterM: 300, speedKms: 18, angleDeg: 35 },
};